import { z } from 'zod';

import { schemaWhatsAppCatalogTemplate } from './schemaWhatsAppCatalogTemplate';

/** Bootstrap; templates required (may be []). */
export const schemaWabaTemplateCatalogCreatedPayload = z.object({
    catalogHash: z.string().min(1),
    templates: z.array(schemaWhatsAppCatalogTemplate),
    wabaId: z.string().min(1),
});

export type Schema_WabaTemplateCatalogCreatedPayload = z.infer<typeof schemaWabaTemplateCatalogCreatedPayload>;
